import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, apiError } from "@/lib/api";
import Seo from "@/components/site/Seo";
import ArticleView from "@/components/site/ArticleView";

/** Anteprima protetta: mostra la bozza come apparirà online, senza pubblicarla né indicizzarla. */
export default function AdminArticlePreview() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get(`/admin/articles/${id}`)
      .then(({ data }) => setArticle(data))
      .catch((err) => setError(apiError(err)));
  }, [id]);

  if (error) return <p className="p-8 text-sm text-destructive" data-testid="preview-error">{error}</p>;
  if (!article) return <p className="p-8 text-sm text-foreground/55">Carichiamo l'anteprima…</p>;

  const references = (article.scientific_sources || [])
    .filter((s) => s.title || s.url)
    .map((s) => ({ title: s.title, journal: s.journal, year: s.year, url: s.url, doi: s.doi }));

  return (
    <div data-testid="admin-article-preview">
      <Seo title={`Anteprima · ${article.title}`} description={article.excerpt} noindex />
      <div className="sticky top-0 z-50 flex flex-wrap items-center justify-between gap-3 bg-wood px-5 py-3 text-cream">
        <p className="text-[0.66rem] uppercase tracking-[0.18em]" data-testid="preview-banner">
          Anteprima privata · stato: {article.status === "published" ? "pubblicato" : "bozza"} · non indicizzabile
        </p>
        <Link
          to="/admin/diario"
          data-testid="preview-back"
          className="inline-flex items-center gap-2 border border-cream/40 px-4 py-2 text-[0.62rem] uppercase tracking-[0.16em] hover:bg-cream hover:text-wood transition-colors duration-400"
        >
          <ArrowLeft size={13} /> Torna agli articoli
        </Link>
      </div>
      <ArticleView article={article} references={references} />
    </div>
  );
}
